import { DEFAULT_DOOR, DEFAULT_WINDOW } from './floorPlanDesignerState.js';

/**
 * @typedef {{
 *   id: string;
 *   name: string;
 *   type: 'door' | 'window';
 *   category: string;
 *   preview2D: 'door-standard' | 'window-standard';
 *   preview3D: 'door-standard' | 'window-standard';
 *   widthMeters: number;
 *   heightMeters: number;
 *   sillHeightMeters: number;
 * }} FloorPlanOpeningCatalogItem
 */

/** @type {FloorPlanOpeningCatalogItem[]} */
export const FLOOR_PLAN_DOOR_CATALOG = [
  {
    id: 'door-standard',
    name: 'Standard door',
    type: 'door',
    category: 'standard',
    preview2D: 'door-standard',
    preview3D: 'door-standard',
    widthMeters: DEFAULT_DOOR.widthMeters,
    heightMeters: DEFAULT_DOOR.heightMeters,
    sillHeightMeters: DEFAULT_DOOR.sillHeightMeters,
  },
];

/** @type {FloorPlanOpeningCatalogItem[]} */
export const FLOOR_PLAN_WINDOW_CATALOG = [
  {
    id: 'window-standard',
    name: 'Standard window',
    type: 'window',
    category: 'standard',
    preview2D: 'window-standard',
    preview3D: 'window-standard',
    widthMeters: DEFAULT_WINDOW.widthMeters,
    heightMeters: DEFAULT_WINDOW.heightMeters,
    sillHeightMeters: DEFAULT_WINDOW.sillHeightMeters,
  },
];

/**
 * @param {'doors' | 'windows'} mode
 * @returns {FloorPlanOpeningCatalogItem[]}
 */
export function getOpeningCatalogForMode(mode) {
  if (mode === 'windows') return FLOOR_PLAN_WINDOW_CATALOG;
  return FLOOR_PLAN_DOOR_CATALOG;
}

/**
 * @param {FloorPlanOpeningCatalogItem} item
 * @returns {string}
 */
export function formatOpeningDimensions(item) {
  const widthCm = Math.round(item.widthMeters * 100);
  const heightCm = Math.round(item.heightMeters * 100);
  return `${widthCm} × ${heightCm} cm`;
}
